import NumPad from "components/common/NumPad";
import PhoneNumberInput from "components/common/PhoneNumberInput/PhoneNumberInput";
import PinInput from "components/common/PinInput";
import Text from "components/common/Text/Text";
import {
  Background,
  FullScreen
} from "components/Gates/LockScreen/LockScreen.style";
import * as React from "react";
import { ReactNode } from "react";
import { Col, Container, Row } from "react-grid-system";
import strings from "static/strings.js";

interface IProps {
  unlockHashedPin?: string;
  budtenderCanUnlock?: boolean;
  pin: string;
  wrongPin?: boolean;
  value: string;
  currentControl: string;
  onClick: () => void;
  onClick1: () => void;
  onTap: (value: string) => void;
  logoutComponent: ReactNode;
}

export default function LockScreen({
  unlockHashedPin,
  budtenderCanUnlock,
  pin,
  wrongPin,
  value,
  currentControl,
  onClick,
  onClick1,
  logoutComponent,
  onTap
}: IProps) {
  return (
    <>
      <Background />
      <FullScreen>
        <Container>
          <Row justify="center" align="center" style={{ height: "100vh" }}>
            <Col sm={6}>
              <Text hero alternate white bold block fullWidth>
                For your security, your session has been locked
              </Text>
              {unlockHashedPin ? (
                <Row>
                  <Col>
                    <Text white alternate h4 block fullWidth>
                      Please enter your pin to continue
                      {budtenderCanUnlock && (
                        <span>
                          , you can also enter your
                          {strings.cashier} pin
                        </span>
                      )}
                      :
                    </Text>
                    <PinInput pin={pin} wrongPin={wrongPin} focused={true} />
                  </Col>
                </Row>
              ) : (
                <>
                  <Row>
                    <Col>
                      <p>Please enter your phone number to continue:</p>
                      <PhoneNumberInput
                        white
                        value={value}
                        fullWidth
                        readOnly
                        largeText
                        invalid={wrongPin}
                        focused={currentControl === "phone"}
                        onClick={onClick}
                      />
                    </Col>
                  </Row>
                  {budtenderCanUnlock && (
                    <Row>
                      <Col>
                        <p>or enter your {strings.cashier} pin to continue:</p>
                        <PinInput
                          pin={pin}
                          wrongPin={wrongPin}
                          onClick={onClick1}
                          focused={currentControl === "pin"}
                        />
                      </Col>
                    </Row>
                  )}
                </>
              )}
              <Row>
                <Col>{logoutComponent}</Col>
              </Row>
            </Col>
            <Col sm={4} offset={{ md: 1 }}>
              <NumPad onTap={onTap} />
            </Col>
          </Row>
        </Container>
      </FullScreen>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/Gates/LockScreen/LockScreen.tsx